export default __webpack_public_path__ + "static/media/icons8-cloud-database-100.fabc5177.svg";